

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * pbajax模块(用于pb接口交互)
 * @author zhenn
 * @time 2016-11-16
 */
var proxyUrl = {
    pro: 'https://proxy.upliveapps.com/index/index',
    dev: 'http://awsbj-proxy.xingyunzhi.cn/index/index',
    stage: 'http://sg-proxy.xingyunzhi.cn/index/index'
};

// let pbajax = {

//     canceled: 0, // 是否被取消

//     do(cfg, data, success = () => {}, timeout = () => {}, fail = () => {}) {
//         let prefix = proxyUrl[pbajax.env()];
//         let _url = prefix + '?' + $.param(cfg);
//         let timer, xhr;
//         this.canceled = 0;
//         timer = setTimeout(function() {
//             timeout();
//         }, 5000);

//         try {
//             xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
//             xhr.open("POST", _url, true);
//             xhr.responseType = "arraybuffer";

//             try {
//                 xhr.send(data.toArrayBuffer());
//             } catch (e) {
//                 xhr.send();
//             }
//         } catch (e) {
//             alert('please upgrade your brower, such as chrome!');
//         }

//         xhr.onreadystatechange = (data)=>{

//             if (xhr.readyState == 4) {
//                 if (xhr.status == 200) {
//                     clearTimeout(timer);
//                     if (!this.canceled) {
//                         success(xhr.response);
//                     }

//                 } else {
//                     if (typeof fail == 'function') {
//                         fail();
//                     }
//                 }
//             }
//         }


//     },
//     query(name, scope) {
//         var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
//             scope = scope || 'search',
//             r = location[scope].substr(1).match(reg);
//         if (r != null) {
//             return unescape(r[2]);
//         }
//         return null;
//     },

//     env() {
//         return this.query('env') || 'pro';
//     },

//     serializeURI(obj) {
//         var result = [];
//         if (typeof obj != 'object') {
//             obj = {};
//         }
//         for (var i in obj) {
//             result.push(i + '=' + encodeURIComponent(obj[i]));
//         }

//         return result.join('&')
//     },

//     cancel() {
//         this.canceled = 1;
//     }
// };

// export default pbajax;


var PbAajx = function () {
    function PbAajx() {
        _classCallCheck(this, PbAajx);

        this.canceled = 0;
    }

    // canceled: 0, // 是否被取消

    _createClass(PbAajx, [{
        key: 'do',
        value: function _do(cfg, data) {
            var success = arguments.length <= 2 || arguments[2] === undefined ? function () {} : arguments[2];

            var _this = this;

            var timeout = arguments.length <= 3 || arguments[3] === undefined ? function () {} : arguments[3];
            var fail = arguments.length <= 4 || arguments[4] === undefined ? function () {} : arguments[4];

            var prefix = proxyUrl[this.env()];
            var _url = prefix + '?' + $.param(cfg);
            var timer = void 0,
                xhr = void 0;
            timer = setTimeout(function () {
                timeout();
            }, 5000);

            try {
                xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
                xhr.open("POST", _url, true);
                xhr.responseType = "arraybuffer";

                try {
                    xhr.send(data.toArrayBuffer());
                } catch (e) {
                    xhr.send();
                }
            } catch (e) {
                alert('please upgrade your brower, such as chrome!');
            }

            xhr.onreadystatechange = function (data) {

                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        clearTimeout(timer);
                        if (!_this.canceled) {
                            success(xhr.response);
                        }
                    } else {
                        if (typeof fail == 'function') {
                            fail();
                        }
                    }
                }
            };
        }
    }, {
        key: 'query',
        value: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || 'search',
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        }
    }, {
        key: 'env',
        value: function env() {
            return this.query('env') || 'pro';
        }
    }, {
        key: 'serializeURI',
        value: function serializeURI(obj) {
            var result = [];
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                obj = {};
            }
            for (var i in obj) {
                result.push(i + '=' + encodeURIComponent(obj[i]));
            }

            return result.join('&');
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.canceled = 1;
        }
    }]);

    return PbAajx;
}();

exports.default = PbAajx;


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-up-pbajax/dist/index.js
// module id = 343
// module chunks = 0